import {useSelector} from "react-redux"
import useForm from "antd/es/form/hooks/useForm"
import {useNavigate} from "react-router-dom"
import {sessionService} from "services/session.service"
import {Button, Card, Checkbox, Form, Input, Modal, Row} from "antd"
import Label from "components/Label"
import {includedDrugs} from "redux/graphSlice"
import {label} from "services/label.service"
import {Decision} from "components/doctor/Decision"
import MedicalInfo from "components/doctor/MedicalInfo"
import Preferences from "components/doctor/Preferences"

const {confirm} = Modal

export default function SelectMedication({sessionId, session}) {
    const drugs = useSelector(includedDrugs)
    const navigate = useNavigate()

    const [form] = useForm()

    const save = values => {
        sessionService.saveDecision(sessionId, values)
            .then(() => navigate(`/doctor/session/${sessionId}`))
    }

    const showConfirm = values => {
        confirm({
            title: label.get("shared.session.finalize.confirm"),
            content:
                <div className="element">
                    <MedicalInfo info={session?.medicalInformation}/>
                    <Preferences info={session?.preferences}/>
                    <Decision info={values}/>
                </div>,
            onOk() {
                save(values)
            }
            ,
            onCancel() {

            },
            id: "finalize-confirm-dialog",
            width: 1000
        })
    }

    return (
        <Card title={<Label id="select-medication" strong/>} style={{width: 500}}>
            <Form form={form} name="medication-form" onFinish={showConfirm} requiredMark={false}>
                <Form.Item name="selectedDrugs">
                    <Checkbox.Group>
                        {drugs.map(drug => <Row><Checkbox key={drug} value={drug}><Label id={drug}/></Checkbox></Row>)}
                    </Checkbox.Group>
                </Form.Item>
                <Label id="decision_notes"/>
                <Form.Item name="decisionRemarks">
                    <Input.TextArea value/>
                </Form.Item>
                <Form.Item>
                    <Button size="large" type="primary" htmlType="submit"><Label id="save-decision"/></Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
